import request from '@/util/server.js'

// export const settled = 'https://ceres.zkthink.com/settled-merchant/#/' // 商家入驻地址
export const settled = 'http://localhost:8080/#/' // 商家入驻地址

// 获取首页导航栏分类
export function getCategory (params) {
  return request({
    url: '/classify/getFirstClassify',
    method: 'get',
    params
  })
}

export function deleteAllSearch () {
  return request({
    url: '/product/deleteAllSearch',
    method: 'post'
  })
}
export function addSuggest (data) {
  return request({
    url: '/app/addSuggest',
    method: 'post',
    data
  })
}

export function getHistory () {
  return request({
    url: '/app/getHistory',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/nav.js